
import * as jose from 'jose'


export const decryptData = async (jwt) => {

    const secret = jose.base64url.decode('zH4NRP1HMALxxCFnRZABFA7GOJtzU_gIj02alfL1lvI')

    try {
        const { payload } = await jose.jwtDecrypt(jwt, secret)
        return payload
    } catch (error) {
        console.log("Error:", error);
        return false
    }
}